module.exports = __webpack_public_path__ + "stem-587ddcc07ee243796e2a1fc385376755.svg";